import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/illustrations/warning.png'


const _hoisted_1 = { class: "_modal bg-white" }
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Luca Education",
    title: "Luca Education",
    height: "60",
    width: "60"
  })
], -1)
const _hoisted_4 = { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "w-full mt-10"
}
const _hoisted_8 = { class: "input-group grid grid-cols-2 items-center mb-10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Lĩnh vực: ", -1)
const _hoisted_10 = {
  key: 0,
  class: "font-bold text-neutral-500 text-right"
}
const _hoisted_11 = { class: "input-group grid grid-cols-2 items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Mục tiêu: ", -1)
const _hoisted_13 = {
  key: 0,
  class: "font-bold text-neutral-500 text-right"
}
const _hoisted_14 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.deleteOneData)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Bạn có muốn tạm dừng mục tiêu này không? "))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, " Bạn có muốn tạm dừng các mục tiêu này không? "))
      ]),
      (!_ctx.deleteOneData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              (_ctx.listData?.skills?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.listData?.skills?.length), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              (_ctx.listData?.goals?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.listData?.goals?.length), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, " Thoát "),
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center whitespace-nowrap",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, " Tạm dừng mục tiêu ")
    ])
  ]))
}